import { render } from "./Item5.vue?vue&type=template&id=cadbd764&scoped=true"
import script from "./Item5.vue?vue&type=script&lang=js"
export * from "./Item5.vue?vue&type=script&lang=js"

import "./Item5.vue?vue&type=style&index=0&id=cadbd764&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cadbd764"

export default script